/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'react-jss';
import { Table, Modal, Row, Select } from 'antd';
import { useSelector, useDispatch } from 'react-redux';

import styles from '../styles';
import { sorter, onFilter, filterDropdown, filterIcon } from '../utils';
import Breadcrumbs from '../Components/Breadcrumbs';
import {
  clearUserTimeActionTracking,
  clearWeeklyPlans,
  getUserTasks,
  getUserTimeActionTracking,
} from '../Actions';
import TaskTable from './TaskTable';
import { currentFinancialYear, financialYears } from '../financial-years';

const UserTracking = props => {
  const { classes } = props;

  const dispatch = useDispatch();

  const [TaskType, setTaskType] = useState(null);
  const [Year, SetYear] = useState(currentFinancialYear);

  const userTimeActionTracking = useSelector(
    state => state.userTimeActionTracking
  );

  useEffect(() => {
    if (Year) {
      dispatch(getUserTimeActionTracking({ year: Year }));
    }

    return () => {
      dispatch(clearUserTimeActionTracking());
    };
  }, [Year]);

  useEffect(() => {
    return () => {
      dispatch(clearUserTimeActionTracking());
      dispatch(clearWeeklyPlans());
    };
  }, []);

  useEffect(() => {
    if (TaskType) {
      dispatch(getUserTasks(TaskType.id, TaskType.type));
    } else {
      dispatch(clearWeeklyPlans());
    }
  }, [TaskType]);

  const columns = useMemo(() => {
    const _columns = [
      {
        title: 'User',
        dataIndex: 'user',
        sorter: sorter('user'),
        onFilter: onFilter('user'),
        filterDropdown,
        filterIcon,
      },
      {
        title: 'Total Tasks',
        dataIndex: 'total',
        sorter: sorter('total'),
        onFilter: onFilter('total'),
        filterDropdown,
        filterIcon,
      },
      {
        title: 'Completed (On time)',
        dataIndex: 'completedOnTime',
        sorter: sorter('completedOnTime'),
        onFilter: onFilter('completedOnTime'),
        filterDropdown,
        filterIcon,
      },
      {
        title: 'Completed (Delayed)',
        dataIndex: 'completedDelayed',
        sorter: sorter('completedDelayed'),
        onFilter: onFilter('completedDelayed'),
        filterDropdown,
        filterIcon,
      },
      {
        title: 'Currently Assigned (On time)',
        dataIndex: 'assignedOnTime',
        sorter: sorter('assignedOnTime'),
        onFilter: onFilter('assignedOnTime'),
        filterDropdown,
        filterIcon,
        render: (text, record) => (
          <span
            onClick={() =>
              setTaskType({ type: 'assignedOnTime', id: record.userId })
            }
          >
            {text}
          </span>
        ),
      },
      {
        title: 'Currently Assigned (Delayed)',
        dataIndex: 'assignedDelayed',
        sorter: sorter('assignedDelayed'),
        onFilter: onFilter('assignedDelayed'),
        filterDropdown,
        filterIcon,
        render: (text, record) => (
          <span
            onClick={() =>
              setTaskType({ type: 'assignedDelayed', id: record.userId })
            }
          >
            {text}
          </span>
        ),
      },
    ];

    return _columns;
  }, []);

  const rowKey = useMemo(() => record => record.user, []);

  const pagination = useMemo(
    () => ({
      defaultPageSize: 20,
      position: ['bottomLeft'],
      showTotal: total => `Total ${total} Records`,
    }),
    []
  );

  const scroll = useMemo(() => ({ x: 1200, y: window.innerHeight - 300 }), []);

  return (
    <>
      <Breadcrumbs
        moduleName="Time & Action"
        moduleLink="/"
        subModuleName="Tracking"
      />
      <div className={classes.tableStyle}>
        <Row>
          <Select
            value={Year}
            style={{ width: 150 }}
            onChange={value => SetYear(value)}
          >
            {financialYears.map(el => (
              <Select.Option key={el} value={el}>
                {el}
              </Select.Option>
            ))}
          </Select>
        </Row>
        <br />
        <Table
          bordered
          size="small"
          columns={columns}
          dataSource={userTimeActionTracking}
          rowKey={rowKey}
          pagination={pagination}
          scroll={scroll}
        />
      </div>
      {TaskType ? (
        <Modal
          onCancel={() => setTaskType(null)}
          visible
          maskClosable={false}
          centered
          width="90%"
          footer={false}
          title="Tasks"
        >
          <TaskTable />
        </Modal>
      ) : null}
    </>
  );
};

UserTracking.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(UserTracking);
